import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["goback"]
    connect()
    {

    }

    handleResponse(event) {
        let successMessage = event.target.dataset["message"];
        if(!successMessage) successMessage = "Success!";

        let toastEvent = null;

        if (event.detail[0].success) {
        toastEvent = new CustomEvent("show-toast", { detail: successMessage });

        setTimeout(() =>
        {
            this.gobackTarget.click()
        }, 500)

        } else {
        toastEvent = new CustomEvent("show-toast", { detail: "An error occurred:\n" + event.detail[0].error })
        }

        window.dispatchEvent(toastEvent);
  }
}